var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('dates-description',{attrs:{"ticket":_vm.ticket}}),_c('refund',{attrs:{"ticket":_vm.ticket}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }